module.exports = __webpack_public_path__ + "static/turtle-creek-house29-ef227a1652c1e6f96d084d4bf491030e.jpg";